"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptPaymentTermsOfService = exports.getAccounts = exports.patchPortalUser = exports.getPortalUser = void 0;

var _Http = require("./Http");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var resource = "users";
var resourceVersion = "1";
var baseUrl = "".concat(resource, "/").concat(resourceVersion, "/");
/**
 * Retrieve patient portal user record
 *
 * @param {*} userId patient portal user id
 * @returns portal user object
 */

var getPortalUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId) {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _Http.get)(baseUrl + "user/".concat(userId));

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getPortalUser(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Update portal user record
 *
 * @param {*} userId patient portal user id of record to update
 * @param {*} data object with data used to update user
 * @returns new portal user object
 */


exports.getPortalUser = getPortalUser;

var patchPortalUser = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userId, data) {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _Http.patch)(baseUrl + "user/".concat(userId), data);

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function patchPortalUser(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Retrieve list of accounts the portal user has billing access for
 *
 * @param {number} userId patient portal user id
 * @returns array of accounts
 */


exports.patchPortalUser = patchPortalUser;

var getAccounts = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(userId) {
    var res;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _Http.get)(baseUrl + "user/".concat(userId, "/accountAccess"));

          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getAccounts(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Marking user acceptance of given terms of service
 *
 * @param {number} userId patient portal user id
 * @param {number} termsTypeId identifier for which terms of service was accepted
 * @returns {number} Http response status number
 */


exports.getAccounts = getAccounts;

var postPortalUserTerms = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(userId, termsTypeId) {
    var data, res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = {
              termsTypeId: termsTypeId
            };
            _context4.next = 3;
            return (0, _Http.post)(baseUrl + "user/".concat(userId, "/terms"), data);

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", res.status);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function postPortalUserTerms(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Mark user acceptance of online payment terms of service
 *
 * @param {number} userId patient portal user id
 * @returns {number} Http response status number
 */


var acceptPaymentTermsOfService = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(userId) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", postPortalUserTerms(userId, 1));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function acceptPaymentTermsOfService(_x7) {
    return _ref5.apply(this, arguments);
  };
}();

exports.acceptPaymentTermsOfService = acceptPaymentTermsOfService;